import React, { useState } from 'react';
import TimeSlot from './TimeSlot';
import './ScheduleWalkthroughComponent.scss';
import { CalendlyEventListener, InlineWidget } from 'react-calendly';
import ServiceRequestTimeslotPicker from '../../pages/ServiceRequest/ServiceRequestTimeslotPicker';
import Avatar from '../Avatar';
import Button from '../Button';
import Loader from '../Loader';
import { variables } from '../../Tenants';

export const ScheduleWalkthroughComponent = (props) => {
  const {
    suite,
    property,
    scheduling_url,
    onEventScheduled,
    onClose,
    onFetchAvailableServiceTimes,
    availableServiceTimes,
    hasCalendlyKey,
    user,
    suiteNumber,
    from,
  } = props;
  const [slotSelected, setSlotSelected] = useState(false);
  const [eventData, setEventData] = useState('');
  const [loader, setLoader] = useState(false);
  const [disableButton, setDisableButton] = useState(true);
  function selectTimeSlot(selectedState) {
    let slots = selectedState.split(' ');
    const servicePreferences = [];
    let theme = localStorage.getItem('theme');
    if (theme === 'Albaster') {
      if (selectedState.includes('7:30 - 11:30')) {
        servicePreferences.push(slots[0] + ':' + '7am-11am');
      } else if (selectedState.includes('11:30 - 3:30')) {
        servicePreferences.push(slots[0] + ':' + '11am-3pm');
      } else {
        servicePreferences.push(slots[0] + ':' + 'all day');
      }
      onFetchAvailableServiceTimes(
        property?.propertyManager?.id,
        servicePreferences
      );
      setSlotSelected(true);
    } else {
      const servicePreferences = [];
      servicePreferences.push(slots[0] + ':' + slots[1]);
      onFetchAvailableServiceTimes(
        property?.propertyManager?.id,
        servicePreferences
      );
      setSlotSelected(true);
    }
  }

  let firstName;
  let lastName;
  let email;
  let profileImage;

  if (from === 'Dashboard') {
    firstName = suite ? suite?.homeOwner?.firstname : user?.firstname;
    lastName = suite ? suite?.homeOwner?.lastname : user?.lastname;
    email = suite ? suite?.homeOwner?.email : user?.email;
    profileImage = suite ? suite?.homeOwner?.profileImage : user.profileImage;
  } else {
    firstName = suite ? suite?.homeOwners?.firstname : user?.firstname;
    lastName = suite ? suite?.homeOwners?.lastname : user?.lastname;
    email = suite ? suite?.homeOwners?.email : user?.email;
    profileImage = suite ? suite?.homeOwners?.profileImage : user.profileImage;
  }

  return (
    <>
      <div className="header">
        <div className="top_coner_box">
          <div className="close_icon" onClick={onClose}>
            <svg
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22 0.125C9.8125 0.125 0.125 9.8125 0.125 22C0.125 34.1875 9.8125 43.875 22 43.875C34.1875 43.875 43.875 34.1875 43.875 22C43.875 9.8125 34.1875 0.125 22 0.125ZM30.4375 32.9375L22 24.5L13.5625 32.9375L11.0625 30.4375L19.5 22L11.0625 13.5625L13.5625 11.0625L22 19.5L30.4375 11.0625L32.9375 13.5625L24.5 22L32.9375 30.4375L30.4375 32.9375Z"
                fill="#797979"
              />
            </svg>
          </div>
          <svg
            width="156"
            height="201"
            viewBox="0 0 156 201"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              opacity="0.11"
              cx="170"
              cy="31"
              r="135"
              stroke="#48C1BF"
              strokeWidth="70"
            />
          </svg>
        </div>
      </div>

      <div
        className="walkthrough_section WalkthroughScroll"
        style={{ width: '98%' }}
      >
        <div className="wrapper">
          <div className="walthrough_box">
            <div className="title_heading text-center">
              <h2>Schedule Walkthrough</h2>
            </div>
            <div className="walthrough_table_box">
              <table>
                <thead>
                  <tr>
                    <th>Property</th>
                    <th className="line_table">
                      <div className="line_table_line"></div>
                    </th>
                    <th>Address</th>
                    <th className="line_table">
                      <div className="line_table_line"></div>
                    </th>
                    <th>{variables.Suite} </th>
                    <th className="line_table">
                      <div className="line_table_line"></div>
                    </th>
                    <th>Homeowner</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td data-title="Property Name">{property?.propertyName}</td>
                    <td className="line_table">
                      <div className="line_table_line"></div>
                    </td>
                    <td data-title="Property Address">
                      <p>
                        {property?.addressLine1 +
                          ', ' +
                          property?.city +
                          ' ' +
                          property?.postalCode}{' '}
                      </p>
                    </td>
                    <td className="line_table">
                      <div className="line_table_line"></div>
                    </td>
                    <td data-title="Suite">
                      {suite ? suite?.number : suiteNumber}
                    </td>
                    <td className="line_table">
                      <div className="line_table_line"></div>
                    </td>
                    <td data-title="Home Owner">
                      <div className="profile_box">
                        <Avatar url={profileImage} />
                        <span style={{ marginLeft: '5px' }}>
                          {firstName} {lastName}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="preferred_appointment_times">
              <div className="calender_box">
                {scheduling_url && hasCalendlyKey ? (
                  <CalendlyEventListener
                    onEventScheduled={(e) => {
                      onEventScheduled(e);
                    }}
                  >
                    <div
                      style={{
                        height: '100vh',
                        width: '90vw',
                        backgroundColor: '#fbfcfd',
                      }}
                    >
                      {/* TODO: we should have some sort of builder to order these fields. */}
                      <InlineWidget
                        url={
                          scheduling_url +
                          `?embed_domain=tcampb.github.io&embed_type=Inline`
                        }
                        prefill={{
                          email: email,
                          name: firstName + ' ' + lastName,
                          customAnswers: {
                            a1: property?.propertyName,
                            a2: suite?.number,
                            a3: '1' + user?.phone, // TODO: For now, the phone numbers should always be prefixed with a 1, but that may change
                          },
                        }}
                      />
                    </div>
                  </CalendlyEventListener>
                ) : !slotSelected ? (
                  <div className="walkthroughTimeSlot">
                    <TimeSlot
                      handleSelectionFormData={(selectedState) =>
                        selectTimeSlot(selectedState)
                      }
                    />
                  </div>
                ) : (
                  <>
                    <ServiceRequestTimeslotPicker
                      availableServiceTimes={availableServiceTimes}
                      setFormData={(e) => {
                        setEventData(e?.scheduledAt);
                        setDisableButton(false);
                      }}
                    />
                    {loader ? <Loader center={true} /> : null}
                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                      <Button
                        label="Confirm"
                        color="teal"
                        size="small"
                        onClick={() => {
                          setLoader(true);
                          onEventScheduled(eventData);
                        }}
                        disabled={disableButton || loader}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
